var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "k-filter-container" },
      [
        _c(
          "v-menu",
          {
            attrs: { "offset-y": "", "close-on-content-click": false },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  return [
                    _c(
                      "v-btn",
                      _vm._g(
                        {
                          staticClass: "k-filter-btn",
                          attrs: {
                            flat: "",
                            icon: "",
                            color: "link",
                            disabled: _vm.disabled
                          },
                          on: { mousedown: _vm.handleBtnMousedown }
                        },
                        on
                      ),
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "k-filter-icon",
                            class: {
                              active: _vm.hasFiltersOrSorts || _vm.showDropdown
                            },
                            attrs: {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 14 14",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M1.5 2.5h11L8 7.5v4l-2-1V7.5L1.5 2.5z",
                                stroke: "currentColor",
                                "stroke-width": "1.4",
                                "stroke-linejoin": "round",
                                "stroke-linecap": "round"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                }
              }
            ]),
            model: {
              value: _vm.showDropdown,
              callback: function($$v) {
                _vm.showDropdown = $$v
              },
              expression: "showDropdown"
            }
          },
          [
            _vm._v(" "),
            _vm.isText
              ? _c(
                  "text-filter-options",
                  {
                    ref: "filter-options",
                    attrs: { sortable: _vm.column.sortable },
                    on: {
                      "set-sort-dir": _vm.setSortDir,
                      "set-filter-operator": _vm.setFilterOperator,
                      "set-empty-filter": _vm.setEmptyFilter,
                      "remove-empty-filter": _vm.removeEmptyFilter
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "k-filter-menu-item k-error-menu-item",
                        attrs: { flat: "", color: "error" },
                        on: { mousedown: _vm.clearColumnFilters }
                      },
                      [_vm._v("\n          Clear All\n        ")]
                    )
                  ],
                  1
                )
              : _vm.isNumeric
              ? _c(
                  "number-filter-options",
                  {
                    ref: "filter-options",
                    attrs: { sortable: _vm.column.sortable },
                    on: {
                      "set-sort-dir": _vm.setSortDir,
                      "set-filter-operator": _vm.setFilterOperator,
                      "set-empty-filter": _vm.setEmptyFilter,
                      "remove-empty-filter": _vm.removeEmptyFilter,
                      "set-between": _vm.setBetween
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "k-filter-menu-item k-error-menu-item",
                        attrs: { flat: "", color: "error" },
                        on: { mousedown: _vm.clearColumnFilters }
                      },
                      [_vm._v("\n          Clear All\n        ")]
                    )
                  ],
                  1
                )
              : _vm.isBoolean
              ? _c(
                  "boolean-filter-options",
                  {
                    ref: "filter-options",
                    on: {
                      "remove-boolean-filter": _vm.removeBooleanFilter,
                      "set-boolean-filter": _vm.setBooleanFilter,
                      "set-sort-dir": _vm.setSortDir
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "k-filter-menu-item k-error-menu-item",
                        attrs: { flat: "", color: "error" },
                        on: { mousedown: _vm.clearColumnFilters }
                      },
                      [_vm._v("\n          Clear All\n        ")]
                    )
                  ],
                  1
                )
              : _c(
                  "date-filter-options",
                  {
                    ref: "filter-options",
                    attrs: {
                      sortable: _vm.column.sortable,
                      "is-utc-time": _vm.isUtcTime
                    },
                    on: {
                      "set-sort-dir": _vm.setSortDir,
                      "set-filter-operator": _vm.setFilterOperator,
                      "set-empty-filter": _vm.setEmptyFilter,
                      "remove-empty-filter": _vm.removeEmptyFilter,
                      "set-between": _vm.setBetween,
                      "add-date-filter": _vm.addDateFilter,
                      "change-date-filter": _vm.changeDateFilter,
                      "remove-date-filter": _vm.removeDateFilter
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "k-filter-menu-item k-error-menu-item",
                        attrs: { flat: "", color: "error" },
                        on: { mousedown: _vm.clearColumnFilters }
                      },
                      [_vm._v("\n          Clear All\n        ")]
                    )
                  ],
                  1
                )
          ],
          1
        ),
        _vm._v(" "),
        _vm.isBetween
          ? _c("between-input", {
              ref: "between-input",
              attrs: { "text-field-type": _vm.textFieldType },
              on: { "add-between-filter": _vm.addBetweenFilter }
            })
          : _vm.isDate
          ? _c("date-input", {
              ref: "input",
              attrs: {
                format: _vm.format,
                label: _vm.filterOperator.label,
                disabled: _vm.disabled
              },
              on: { "set-filters": _vm.setFilters }
            })
          : _c("v-text-field", {
              ref: "input",
              staticClass: "k-filter-v-input",
              attrs: {
                label: _vm.label,
                value: _vm.inputValue,
                type: _vm.textFieldType,
                disabled: _vm.disabled || _vm.isBoolean,
                mask: _vm.inputMask,
                "hide-details": "",
                dense: "",
                box: "",
                "append-icon": "search"
              },
              on: {
                input: _vm.handleFilterInput,
                keydown: _vm.handleFilterKeydown,
                focus: _vm.handleInputFocus,
                blur: _vm.handleInputBlur,
                "click:append": _vm.handleSearchClick
              }
            })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        style:
          _vm.showFilters && _vm.activeFilters.length
            ? "border-top: 1px solid var(--sb-table-header-border, #e2e8f0)"
            : ""
      },
      [
        _vm.showFilters
          ? _c(
              "div",
              {
                ref: "chipcontainer",
                staticStyle: { display: "flex", "flex-wrap": "wrap" }
              },
              _vm._l(_vm.activeFilters, function(activeFilter, index) {
                return _c(
                  "v-chip",
                  {
                    key: index,
                    ref: "filterchip",
                    refInFor: true,
                    staticClass: "k-active-filter-chip",
                    attrs: { close: "" },
                    on: {
                      input: function($event) {
                        return _vm.handleRemoveFilterClick(activeFilter, index)
                      }
                    }
                  },
                  [
                    _c(
                      "pre",
                      {
                        class: {
                          "k-active-filter-chip__label--ellipsis":
                            activeFilter &&
                            activeFilter.label &&
                            activeFilter.label.length > 10,
                          "k-active-filter-chip__label--wrap":
                            activeFilter &&
                            activeFilter.label &&
                            activeFilter.label.length < 10
                        }
                      },
                      [_vm._v(_vm._s(activeFilter.label))]
                    )
                  ]
                )
              }),
              1
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }